import { getIsPageTearingDown } from '~/utils/pageTeardown';
import {
  recordSuppressedError,
  SuppressedErrorReason,
} from '~/utils/suppressedErrorTelemetry';

const RELOAD_MARKER_KEY = 'chunkLoadRecoveryReloadedAt';
const RELOAD_COOLDOWN_MS = 30_000;

function hasRecentlyReloaded() {
  const marker = window.sessionStorage.getItem(RELOAD_MARKER_KEY);
  if (!marker) return false;

  const elapsed = Date.now() - Number(marker);
  return (
    Number.isFinite(elapsed) && elapsed >= 0 && elapsed < RELOAD_COOLDOWN_MS
  );
}

export function startChunkLoadRecovery() {
  window.addEventListener('vite:preloadError', (event) => {
    const module = event.payload?.message ?? 'unknown';

    if (getIsPageTearingDown()) {
      recordSuppressedError(SuppressedErrorReason.ChunkLoadDuringTeardown, {
        module,
      });
      return;
    }

    // Without the cooldown a chunk that is permanently gone reloads forever.
    if (hasRecentlyReloaded()) {
      recordSuppressedError(SuppressedErrorReason.ChunkLoadReloadSuppressed, {
        module,
      });
      return;
    }

    recordSuppressedError(
      SuppressedErrorReason.ChunkLoadReload,
      { module },
      { flushImmediately: true },
    );

    event.preventDefault();
    window.sessionStorage.setItem(RELOAD_MARKER_KEY, String(Date.now()));
    window.location.reload();
  });
}
